export default __webpack_public_path__ + "static/media/emptyw.a14a2707.svg";